import React from 'react';
import styled from '@emotion/styled';

export const ButtonComponent = () => {
  return (
    <ButtonContainer>
      <SubmitButton type='submit'>{`로그인`}</SubmitButton>
    </ButtonContainer>
  );
};

const ButtonContainer = styled.article`
  margin: 50px 0;
  @media screen and (max-width: 992px) {
    margin-bottom: 25px;
  }
`;

const SubmitButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 60px;
  border: 2px solid #002366;
  background-color: #ffffff;
  border-radius: 10px;
  font-size: 25px;
  font-weight: bold;
  color: #002366;
  :disabled {
    border: 2px solid #c4c4c4;
    color: #c4c4c4;
  }
  @media only screen and (max-width: 992px) {
    font-size: 20px;
  }
`;
